import moment from 'moment';

import { IDeploymentRunner } from 'app/shared/model/FDEExtractorRunnerService/runner-command.model';

export type RunnerState = 'RUNNING' | 'STOPPED' | 'UNREACHABLE';

export const RUNNER_STALE_SEC = 90;

export function isRunnerReachable(runner: IDeploymentRunner): boolean {
    return !!runner.lastSeenAt && moment().diff(runner.lastSeenAt, 'seconds') < RUNNER_STALE_SEC;
}

export function runnerState(runner: IDeploymentRunner): RunnerState {
    if (!isRunnerReachable(runner)) {
        return 'UNREACHABLE';
    }
    return runner.runnerUp ? 'RUNNING' : 'STOPPED';
}

export function runnerStateColor(state: RunnerState): string {
    switch (state) {
        case 'RUNNING':
            return '#228B22';
        case 'STOPPED':
            return '#6c757d';
        default:
            return '#E10101';
    }
}
